import { Link } from 'react-router-dom';

import { ReactComponent as CremationPlotIcon } from 'src/assets/icons/cremation-plot.svg';
import { ReactComponent as CryptIcon } from 'src/assets/icons/crypt.svg';
import { ReactComponent as GreenBurialIcon } from 'src/assets/icons/green-burial.svg';
import { ReactComponent as InfantIcon } from 'src/assets/icons/infant.svg';
import { ReactComponent as NicheIcon } from 'src/assets/icons/niche.svg';
import { ReactComponent as OssuaryIcon } from 'src/assets/icons/ossuary.svg';
import { ReactComponent as PlotIcon } from 'src/assets/icons/plot.svg';

import { LotType, LotTypeShown, ServiceType } from 'src/constants';
import { useLocalization } from 'src/contexts/localization-context';
import { getLotTypeFilterUrl, getServiceTypeLabel } from 'src/utils';
import type { BurialTypeProps } from './burial-type.props';

import './burial-type.scss';

const BurialTypeIcon = {
  [LotType.CREMATION_PLOT]: CremationPlotIcon,
  [LotType.CRYPT]: CryptIcon,
  [LotType.NICHE]: NicheIcon,
  [LotType.PLOT]: PlotIcon,
  [LotType.OSSUARY]: OssuaryIcon,
  [LotType.GREEN_BURIAL]: GreenBurialIcon,
  [LotType.INFANT]: InfantIcon,
};

const BurialType = ({ type }: BurialTypeProps) => {
  const { getLocalization } = useLocalization();
  const Icon = BurialTypeIcon[type];
  const serviceType =
    type === LotType.NICHE || type === LotType.CRYPT
      ? ServiceType.MAUSOLEUM
      : ServiceType.IN_GROUND;

  return (
    <Link className="burial-type" to={getLotTypeFilterUrl(type)}>
      <Icon className="burial-type__icon" />
      <span className="burial-type__info">
        <span className="burial-type__category">
          {getLocalization(getServiceTypeLabel(type, serviceType))}
        </span>
        <span className="burial-type__name">{getLocalization(LotTypeShown[type])}</span>
      </span>
    </Link>
  );
};

export default BurialType;
